import { Box, Typography } from "@material-ui/core"
import React from "react"
import * as pattern from "patternomaly"

interface LegendItemProps {
  color: string
  label: string
  percentage: string
  count: number
  hidePercentage?: boolean
  hideNumber?: boolean
  patternType?: "line" | "diagonal" | "square" | "zigzag"
}

const LegendItem: React.FC<LegendItemProps> = ({
  color,
  label,
  percentage,
  count,
  hidePercentage,
  hideNumber,
  patternType,
}) => {
  // Generate a canvas-based pattern and convert it to a data URL
  const generatePattern = (patternType: any, color: string) => {
    const canvas = document.createElement("canvas")
    canvas.width = 20
    canvas.height = 20
    const ctx = canvas.getContext("2d")
    if (ctx) {
      const generatedPattern = pattern.draw(patternType, color)
      ctx.fillStyle = generatedPattern as CanvasPattern
      ctx.fillRect(0, 0, canvas.width, canvas.height)
    }
    return canvas.toDataURL()
  }

  const background = patternType ? generatePattern(patternType, color) : color

  return (
    <Box display="flex" mt={1} mr={2}>
      <Box display="flex" flexDirection="row" alignItems="center">
        <Box
          width="16px"
          height="16px"
          bgcolor={color}
          mr={1}
          borderRadius="4px"
          style={{
            backgroundImage: `url(${background})`,
            backgroundColor: color,
            backgroundSize: "cover",
          }}
        />
        <Typography variant="body2">
          {label}
          <span style={{ marginLeft: "4px" }}>
            {hidePercentage ? "" : `${percentage}%`} {hideNumber ? "" : `(${count})`}
          </span>
        </Typography>
      </Box>
    </Box>
  )
}

export default LegendItem
